module.exports = __webpack_public_path__ + "assets/img/html_css_js.d70fc4ee.jpg";